import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentcmsService } from 'projects/authentication/_services/contentcms.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalService } from 'src/app/_core/global.service';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { EventsService } from 'src/app/_core/_services/events.service';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.scss']
})
export class VouchersComponent implements OnInit {

  public Contents: any[];
  public totalVoucher: number;
  public loading_: boolean = false;

  private page_: number = 1;
  private count_: number = 12;

  constructor(
    private contSvc: ContentcmsService,
    private global: GlobalService,
    private router: Router,
    private beh: BehaviorService,
    private event: EventsService
  ) {
    this.loadContents();
  }

  ngOnInit(): void {
    this.event.eventStart({ eventType: 'CONTENT_LIST_PAGE_ACCESS', eventCategory: 'ACCESS' });
  }

  private _subs = new Subject();
  ngOnDestroy() {
    this._subs.next();
    this._subs.complete();
  }

  public loadContents(more: boolean = false) {
    if (!!this.beh.mainContentCallResp.value && !more) {
      this.Contents = this.beh.mainContentCallResp.value.content;
      this.totalVoucher = this.beh.mainContentCallResp.value.total;
      this.page_ = this.beh.mainContentCallResp.value.page;
    } else {
      this.loading_ = true;
      this.contSvc.getContent('content', { useCache: true, count: this.count_, page: this.page_, withReferences: false }).pipe(takeUntil(this._subs)).subscribe(cont => {
        this.totalVoucher = +cont?.additionalFields?.totalSize || 0;
        this.Contents = !this.Contents?.length ? this.global.entitysToPlain(cont?.list || []) : [...this.Contents, ...this.global.entitysToPlain(cont?.list || [])];
        this.page_++;
        this.beh.mainContentCallResp.next({ content: this.Contents, total: this.totalVoucher, page: this.page_ });
        this.loading_ = false;
      }, () => {
        this.Contents = this.Contents || [];
        this.loading_ = false;
      });
    }
  }

  public navigate(path: string[]) {
    this.router.navigate(path, { queryParamsHandling: 'merge' });
  }

}